import { createApi } from '@reduxjs/toolkit/dist/query/react';

import { baseQueryWithIntercept } from '@apis/fetchBaseQuery';
import {
    LocateProductlDTO,
    LocateProductResponse,
    REQUEST_PATH
} from '@apis/manageInventory/LocateProduct.type';
import { GetBasicDtoPagination } from '@customTypes/api/api.types';
import { GetProductTransformedResponse } from '@customTypes/general/product.types';
import { getTransformedDataWithHazard } from '@helpers/apiFormatter';
import { getBasePaginationBody } from '@helpers/getBasePaginationBody';

export const locateProductApi = createApi({
    reducerPath: 'locateProductApi',
    baseQuery: baseQueryWithIntercept,
    endpoints: (builder) => ({
        locateProduct: builder.mutation<
            LocateProductResponse,
            LocateProductlDTO
        >({
            query: (dto) => ({
                url: REQUEST_PATH.LOCATE_PRODUCT,
                method: 'POST',
                body: dto
            })
        }),
        getLocateProductParts: builder.mutation<
            GetProductTransformedResponse,
            GetBasicDtoPagination
        >({
            query: (dto) => ({
                url: REQUEST_PATH.PARTS,
                method: 'POST',
                body: getBasePaginationBody({
                    ...dto,
                    filterFields: 'CustomDescription',
                    fixedSorter: 'partNumber'
                })
            }),
            transformResponse: getTransformedDataWithHazard
        })
    })
});

export const { useLocateProductMutation, useGetLocateProductPartsMutation } =
    locateProductApi;
